import {
	ladlesRepository,
	setRootStateArgs,
} from "@/repositories/roots/ladlesRepository";
import { createAsyncThunk } from "@reduxjs/toolkit";

/**
 * Fetch LadleOverview Table
 */
export const getLadleOverviewTable = createAsyncThunk(
	"@ladle-overview/getLadleOverviewTable",
	async (withComponents: boolean = true) => {
		return await ladlesRepository.getLadlesWithComponents(withComponents);
	},
);

export const submitSetRootState = createAsyncThunk(
	"@ladle-oveview/setRootState",
	async (
		data: {withComponents: boolean, data: setRootStateArgs },
		{ dispatch, rejectWithValue, fulfillWithValue },
	) => {
		try {
			const resp = await ladlesRepository.setRootState(data.data);
			await dispatch(getLadleOverviewTable(data.withComponents));
			return fulfillWithValue(resp.data);
		} catch (e) {
			return rejectWithValue(e);
		}
	},
);
